import React, { useEffect, useState } from 'react';

// const FORMS = styled.div`
// 	width: 392px;
// 	& > p {
// 		color: ${(props) => {
// 			if (props.cssPtag) {
// 				return 'var(--colorScale-1)';
// 			}
// 			return props.colorMode === 'dark' ? 'white' : 'var(--colorScale-1)';
// 		}};
// 		margin-bottom: 8px !important;
// 		font-weight: 600;
// 		&.ff-chatbot-caption {
// 			margin-bottom: 16px !important;
// 			font-weight: normal;
// 			color: ${(props) => {
// 				if (props.cssPtag) {
// 					return 'var(--black-60)';
// 				}
// 				return props.colorMode === 'dark' ? 'white' : 'var(--black-60)';
// 			}};
// 		}
// 	}
// 	& > .ff-checkbox {
// 		margin-bottom: 16px;
// 		& > label {
// 			gap: 8px;
// 			& > .check {
// 				& path:last-child {
// 					fill: ${(props) => {
// 						if (props.cssPtag) {
// 							return 'var(--colorScale-1) !important';
// 						}
// 						return props.colorMode === 'dark' ? 'white' : 'var(--colorScale-1)';
// 					}};
// 				}
// 			}
// 			& > .label {
// 				& > p {
// 					color: ${(props) => {
// 						if (props.cssPtag) {
// 							return 'initial !important';
// 						}
// 					}};
// 				}
// 			}
// 		}
// 	}
// 	& > .MuiFormGroup-root {
// 		margin-bottom: 16px;
// 		& > label {
// 			& > .MuiTypography-root {
// 				& > p {
// 					color: ${(props) => {
// 						if (props.cssPtag) {
// 							return 'initial !important';
// 						}
// 						return props.colorMode === 'dark' ? 'white' : 'var(--colorScale-1)';
// 					}};
// 				}
// 			}
// 			& > span.MuiButtonBase-root {
// 				& path {
// 					fill: ${(props) => {
// 						if (props.cssPtag) {
// 							return 'var(--colorScale-1) !important';
// 						}
// 						return props.colorMode === 'dark' ? 'white' : 'var(--colorScale-1)';
// 					}};
// 				}
// 			}
// 		}
// 	}
// 	& > div > .MuiFormControl-root {
// 		margin-bottom: 24px !important;
// 		& input {
// 			font-size: 14px !important;
// 			color: var(--black-60);
// 		}
// 		& .MuiInputBase-root {
// 			background-color: white;
// 			&:not(.Mui-disabled, .Mui-error).Mui-focused {
// 				.MuiOutlinedInput-notchedOutline {
// 					border-color: ${(props) => {
// 						if (props.cssPtag) {
// 							return 'var(--colorScale-1) !important';
// 						}
// 						return props.colorMode === 'dark' ? 'white' : 'var(--colorScale-1)';
// 					}};
// 				}
// 			}
// 		}
// 		& .MuiFormHelperText-root {
// 			color: ${(props) => {
// 				if (props.cssPtag) {
// 					return 'var(--colorScale-1) !important';
// 				}
// 				return props.colorMode === 'dark' ? 'white' : 'var(--colorScale-1)';
// 			}};
// 		}
// 	}
// 	& > div {
// 		& > .custom-button:last-child {
// 			padding-top: 12px;
// 			width: ${(props) => (props.cssPtag ? '50%' : '90px')};
// 			& > button {
// 				background-color: ${(props) => {
// 					return props.colorMode === 'dark'
// 						? 'var(--colorScale-9)'
// 						: 'var(--colorScale-8)';
// 				}} !important;
// 				& > .custom-button-body {
// 					color: ${(props) => {
// 						return props.colorMode === 'dark'
// 							? 'var(--selectedColor)'
// 							: 'var(--colorScale-3)';
// 					}} !important;
// 				}
// 			}
// 		}
// 		& > .custom-button:first-child {
// 			padding-top: 12px;
// 			width: ${(props) => (props.cssPtag ? '50%' : '90px')};
// 			& > button {
// 				background-color: ${(props) => {
// 					if (props.cssPtag) {
// 						return props.colorMode === 'dark'
// 							? 'var(--selectedColor)'
// 							: 'var(--colorScale-2) ';
// 					}
// 					return props.colorMode === 'dark' ? 'white' : 'var(--colorScale-2)';
// 				}} !important;
// 				& > .custom-button-body {
// 					color: ${(props) => {
// 						if (props.cssPtag) {
// 							return 'white';
// 						}
// 						return props.colorMode === 'dark'
// 							? 'var(--selectedColor)'
// 							: 'white';
// 					}} !important;
// 				}
// 			}
// 		}
// 	}
// 	& > div {
// 		& > .MuiAutocomplete-root {
// 			margin-bottom: 24px !important;
// 			& .MuiInputBase-root {
// 				background-color: white;
// 				padding: 6px !important;
// 				padding-left: 10px !important;

// 				&:not(.Mui-disabled, .Mui-error).Mui-focused {
// 					.MuiOutlinedInput-notchedOutline {
// 						border-color: var(--colorScale-1) !important;
// 					}
// 				}
// 			}
// 		}
// 	}
// `;

type Props = {
	// handleSubmit: Function;
	// WorkflowData: any;
	// colorMode: string;
	// token: any;
	// botId: any;
	// tenantId: any;
	// conversationId: any;
	// cssPtag?: any;
	// addUserResponse: Function;
	// currentWorkflow: string;
	// changeScreen?: Function;
	// showToaster?: Function;
	// disableMandatory?: Function;
	// shouldDisableActions?;
	images;
	title;
	isReason;
	ffstore;
};

const ImageDisplay = ({ images, title, isReason, ffstore }: Props) => {
	const [selectedImage, setImage] = useState(0);

	return (
		<div className='ff-product-image'>
			<div className='ff-product-preview'>
				{/* <img src={images} /> */}
				<img src={images} />

				{/* {ffstore ?
					<img src={images} />
					:
					<img src={images[selectedImage] && images[selectedImage].src} />
				} */}
			</div>
			{/* {!ffstore && images && images.length > 1 && (
				<div className='ff-product-image-array'>
					{images.map((item, index) => {
						return (
							<div
								className={`ff-product-image-item ${
									selectedImage == index ? 'active' : ''
								}`}
								onClick={() => {
									setImage(index);
								}}
							>
								<img src={item.src} />
							</div>
						);
					})}
				</div>
			)} */}
			{/* {isReason && (
				<div style={{ fontSize: '16px', fontWeight: 'bold' }}>{title}</div>
			)} */}
		</div>
	);
};

export default ImageDisplay;
